import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  IPayeeResponse,
  IPayerEngagementResponse,
  IWorkLog
} from "@wingspanhq/payments/dist/interfaces";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import { DataView } from "../../../shared/components/DataView";
import { getWorkLogPayerStatusPill } from "../utils/getWorkLogPayerStatusPill";

type Props = {
  shimmer?: boolean;
  workLog?: IWorkLog;
  payee?: IPayeeResponse;
  payerPayeeEngagement?: IPayerEngagementResponse;
};

export const WorkLogAssignmentInfoPayerView: React.FC<Props> = props => {
  const statusPill = props.workLog
    ? getWorkLogPayerStatusPill(props.workLog)
    : undefined;

  const names = props.payee
    ? wsName({
        user: {
          email: props.payee.user?.email as string,
          profile: props.payee.user?.profile
        },
        member: props.payee.member
      })
    : undefined;

  return (
    <WSElement>
      <WSSectionToolbar title="Assignment information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Assignment name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            pill: statusPill,
            hideValue: true
          },
          { label: "Contractor name", value: names?.getResolvedName() }
        ]}
      />
    </WSElement>
  );
};
